<template>
    <v-layout justify-center>
        <v-responsive max-width="1080px" width="100%" class="px-0 px-md-4 px-xl-8">
            <v-row class="mt-0 mt-md-8" justify="center" align="center">
                <v-col cols="auto" class="pt-0 pb-0 headline text-start">
                    <v-layout align-center> 정산 상세 </v-layout>
                </v-col>
                <v-spacer />
            </v-row>
            <template v-if="settlement">
                <v-row class="mt-8">
                    <v-col cols="8">
                        <info-settlement :settlement="settlement" />
                        <info-store :store="settlement.store" />
                    </v-col>
                    <v-col cols="4">
                        <v-card>
                            <v-card-title>정산메모</v-card-title>
                            <v-card-text>
                                <v-textarea v-model="settlement.memo" placeholder="특이사항 메모" class="my-0 py-0" hide-details :rows="isEditable ? 9 : 10" :readonly="isEditable ? false : true" />
                            </v-card-text>
                            <v-card-actions v-if="isEditable">
                                <v-row justify="end">
                                    <v-col cols="auto">
                                        <v-btn small color="secondary" @click="put">메모 저장</v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-col>
                        <info-detail v-model="settlement" @input="put" />
                    </v-col>
                </v-row>
                <v-row justify="center" class="mt-4">
                    <v-col cols="auto" v-if="isEditable">
                        <v-btn v-if="!settlement.isDone" @click="settle" color="primary">
                            정산하기
                        </v-btn>
                        <v-btn v-else disabled>
                            정산완료
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import infoSettlement from "@/components/console/shop/settlements/info-settlement.vue";
import InfoStore from "@/components/console/shop/settlements/info-store.vue";
import InfoDetail from "@/components/console/shop/settlements/info-detail.vue";

export default {
    components: {
        infoSettlement,
        InfoStore,
        InfoDetail,
    },
    data() {
        return {
            settlement: null,
        };
    },
    computed: {
        isConsole() {
            return this.$store.state.scope.includes("console");
        },
        isEditable() {
            return this.isConsole && !this.settlement.isDone;
        },
    },
    mounted() {
        this.search();
    },
    methods: {
        async search() {
            try {
                const { settlement } = await api.console.shop.settlements.get({
                    _id: this.$route.params._settlement,
                });

                this.settlement = settlement;
            } catch (error) {
                this.handleError(error);
            }
        },
        async put() {
            try {
                const { settlement } = await api.console.shop.settlements.put(this.settlement);

                this.settlement = settlement;
            } catch (error) {
                this.handleError(error);
            }
        },
        settle() {
            if (this.settlement.amounts.some(({ save }) => save)) {
                alert("수동처리를 모두 저장하셔야 정산하실 수 있습니다.");
                return;
            }
            const isDone = confirm("입력하신 정보로 정산하시겠습니까?");
            if (isDone) {
                this.settlement.isDone = true;
                this.put();
            }
        },
        handleError(error) {
            console.error(error);
            alert(error.response ? error.response.data.message : error.message);
        },
    },
};
</script>
